import Load from 'components/Load';
import { createNavigationalRoute } from 'modules/app/components/NavigationalLayout';
import { RouteDescriptor, createRouteHandle } from 'routing/types';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';

const AppPromo = Load(
  () => import(/* webpackChunkName: "app-page" */ './components/AppPromoPage'),
  {},
  true,
);

export const appPromoRoute: RouteDescriptor = {
  id: 'landings.app-promo',
  path: `${basePath}/app`,
  label: 'App Promo Landing',
  audience: 'both',
  layout: 'navigational',
  module: 'landings/app-promo',
};

export const appPromoRoutes = [
  createNavigationalRoute({
    key: appPromoRoute.id,
    id: appPromoRoute.id,
    path: appPromoRoute.path,
    component: AppPromo,
    handle: createRouteHandle(appPromoRoute),
    noNavbar: isCordova(),
    showBottomNavigation: true,
  }),
];

export const appPromoRouteDescriptors = [appPromoRoute];

export default appPromoRoutes;
